import { useEffect } from 'react';
import { SITE } from './siteData';

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement('link'); el.setAttribute('rel', rel); document.head.appendChild(el); }
  el.setAttribute('href', href);
}

/**
 * Per-page SEO. Sets title, description, keywords, canonical, Open Graph,
 * Twitter card and any number of JSON-LD blocks (schema) for the page.
 */
export default function Seo({ title, description, keywords, path = '/', schema = [], image }) {
  useEffect(() => {
    const url = `${SITE.url}${path === '/' ? '/' : path}`;
    const img = image || SITE.ogImage;
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    setMeta('name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setLink('canonical', url);

    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', img);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', SITE.name);
    setMeta('property', 'og:locale', SITE.locale);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', img);

    const added = [];
    (Array.isArray(schema) ? schema : [schema]).filter(Boolean).forEach((s, i) => {
      const el = document.createElement('script');
      el.type = 'application/ld+json';
      el.setAttribute('data-seo', `page-${i}`);
      el.text = JSON.stringify(s);
      document.head.appendChild(el);
      added.push(el);
    });
    return () => added.forEach(el => el.remove());
  }, [title, description, keywords, path, image, schema]);

  return null;
}

export const breadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map(([name, path], i) => ({
    '@type': 'ListItem', position: i + 1, name, item: `${SITE.url}${path}`,
  })),
});

export const webPage = (name, path, description, type = 'WebPage') => ({
  '@context': 'https://schema.org',
  '@type': type,
  '@id': `${SITE.url}${path}#webpage`,
  url: `${SITE.url}${path}`,
  name, description,
  isPartOf: { '@id': 'https://vtcodex.com/#website' },
  about: { '@id': 'https://vtcodex.com/#organization' },
  inLanguage: 'en-IN',
});
